/** Items that survive fire and lava as dropped entities (vanilla `fire_resistant`: everything netherite, the nether star, ancient debris). */
import { ANCIENT_DEBRIS_ID } from '../../blocks';
import { I, itemNameOf } from '../itemIds';

export function isFireproofItem(id: number): boolean {
  if (id === ANCIENT_DEBRIS_ID || id === I.NETHER_STAR) return true;
  const n = itemNameOf(id);
  return !!n && n.startsWith('NETHERITE_');
}
